import { ScreeningQuestionsConfig } from 'config-types/config/screening-questions';
import {
  PATIENT_BREASTFEEDING_STATUS,
  PATIENT_PREGNANCY_STATUS,
  PatientBreastfeedingKeys,
  PatientPregnancyKeys,
} from '../../types/data/screening-questions/constants';
import { BRANDING_CONFIG } from '../branding';

export const patientScreeningQuestionsConfig: ScreeningQuestionsConfig = {
  title: 'ASK THE PATIENT',
  fields: [
    {
      id: 'seen_in_last_3_years',
      type: 'radio',
      question: `Have you been a patient of ${BRANDING_CONFIG.projectName} anytime in the past 3 years?`,
      fhirField: 'seen-in-last-3-years',
      existsInQuestionnaire: true,
      hideInVirtualPaperwork: true,
      options: [
        { value: 'yes', label: 'Yes', fhirValue: 'Yes' },
        { value: 'no', label: 'No', fhirValue: 'No' },
      ],
    },
    {
      id: 'pregnancy_status',
      type: 'radio',
      question: 'Is there any chance you could be pregnant?',
      fhirField: PATIENT_PREGNANCY_STATUS,
      options: [
        { value: 'yes', label: 'Yes', fhirValue: PatientPregnancyKeys.Yes },
        { value: 'no', label: 'No', fhirValue: PatientPregnancyKeys.No },
        { value: 'not_sure', label: 'Not sure', fhirValue: PatientPregnancyKeys.NotSure },
        { value: 'not_applicable', label: 'Not applicable', fhirValue: PatientPregnancyKeys.NotApplicable },
      ],
    },
    {
      id: 'breastfeeding_status',
      type: 'radio',
      question: 'Are you currently breastfeeding?',
      fhirField: PATIENT_BREASTFEEDING_STATUS,
      options: [
        { value: 'yes', label: 'Yes', fhirValue: PatientBreastfeedingKeys.Yes },
        { value: 'no', label: 'No', fhirValue: PatientBreastfeedingKeys.No },
        { value: 'not_applicable', label: 'Not applicable', fhirValue: PatientBreastfeedingKeys.NotApplicable },
      ],
    },
  ],
};
